// Key-value storage behind the SaveService (IMPLEMENTATION §2.1 save/storage.ts): localStorage in the app,
// an in-memory map in tests. localStorage can throw (Safari private mode, quota, blocked site data): every
// access is guarded, and a failed write reports false instead of throwing.

export interface KeyValueStore {
  get(key: string): string | null;
  /** false when the write failed (quota, blocked storage). */
  set(key: string, value: string): boolean;
  remove(key: string): void;
}

export function memoryStore(init: Record<string, string> = {}): KeyValueStore & {
  dump(): Record<string, string>;
} {
  const m = new Map<string, string>(Object.entries(init));
  return {
    get: (k) => m.get(k) ?? null,
    set(k, v) {
      m.set(k, v);
      return true;
    },
    remove(k) {
      m.delete(k);
    },
    dump: () => Object.fromEntries(m),
  };
}

export function localStore(win: Window): KeyValueStore {
  const ls = (): Storage | null => {
    try {
      return win.localStorage;
    } catch {
      return null;
    }
  };
  return {
    get(k) {
      try {
        return ls()?.getItem(k) ?? null;
      } catch {
        return null;
      }
    },
    set(k, v) {
      try {
        const s = ls();
        if (!s) return false;
        s.setItem(k, v);
        return true;
      } catch {
        return false;
      }
    },
    remove(k) {
      try {
        ls()?.removeItem(k);
      } catch {
        // storage blocked: nothing to remove
      }
    },
  };
}
